export default __webpack_public_path__ + "static/media/e-nstitute-mobile-three.76ccd054.png";